import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import queryString from 'query-string';
import { Input, InputGroup, InputGroupAddon, Button, Collapse } from 'reactstrap';

import SearchSuggestions from './ui-elements/SearchSuggestions';



class SearchInput extends Component {

  constructor(props) {
    super(props);
    this.state = {
      query: '',
      showSuggestions: false
    }
    this.handleSubmit = this.handleSubmit.bind(this);
  }
  handleQuery = (e) => {
    if (e.key === 'Enter') {
      this.handleSubmit(e)
    }
  }
  handleChange = (e) => {
    this.setState({
      query: e.target.value
    }, () => {
      if(this.state.query === ''){
        this.setState({
          showSuggestions: true
        });
      } else {
        this.setState({
          showSuggestions: false
        });
      }
    })
  }
  handleSubmit(e){
    e.preventDefault();
    if(this.state.query){
      this.props.history.push(`/search?q=${this.state.query}`);
    }
  }
  handleFocus = () => {
    this.setState({
      showSuggestions: true
    });
  }
  componentWillMount() {
    const query = queryString.parse(this.props.location.search)['q'];
    this.setState({
      query
    });
  }

  render() {

    const style = {
      overlay: {
        position: 'fixed',
        top: 0,
        left: 0,
        bottom: 0,
        right: 0,
        opacity: 0,
        zIndex: 9999
      }
    }

    return (
      <form className={(this.props.className+" " || "") + "paul-search-form"} style={{position: 'relative', ...this.props.style}} onSubmit={this.handleSubmit}>
        <InputGroup className="d-flex align-items-stretch justify-content-center rounded">
          <Input
            value={this.state.query}
            className='search-input paul-search-input'
            onKeyPress={this.handleQuery}
            onChange={this.handleChange}
            onFocus={this.handleFocus}
            tabIndex="1"
            style={{ flex: 1, height: 40, minWidth: 20, zIndex: 10000 }}
          />
          <InputGroupAddon addonType="append">
            <Button color="primary" className="paul-search-submit-button" onClick={this.handleSubmit} style={{ height: 40 }} >
              <img src='/imgs/symbol_magglass_white.svg' alt="search" style={{width: 20, height: 'auto'}} />
            </Button>
          </InputGroupAddon>
        </InputGroup>

        { this.props.suggestions &&
          <React.Fragment>
            { this.state.showSuggestions && <div id="suggestion_overlay" className="paul-suggestions-overlay" style={style.overlay} onClick={ () => this.setState({showSuggestions: false}) }></div> }
            <Collapse isOpen={this.state.showSuggestions} className="rounded shadow-sm" style={{ overflow: 'hidden', position: 'absolute', top: '100%', width: '100%', zIndex: 10000 }}>
              <SearchSuggestions />
            </Collapse>
          </React.Fragment>
        }
      </form>
    )
  }
}

function mapStateToProps(state) {
  return {
    query: state.query,
  }
}

export default withRouter(connect(mapStateToProps)(SearchInput));



// WEBPACK FOOTER //
// ./src/components/SearchInput.js